import React, { Component } from 'react';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ParticlesContainer from '../dashboard/ParticlesContainer';
import { withRouter } from "react-router";
import M from 'materialize-css';


const jumbotronStyle = {
  paddingBottom: '60px',
  paddingTop: '80px',
  boxShadow: "0px 0px 0px 0px rgba(0,0,0,0)",
  position: "relative",
  zIndex: "999",
}

const insideStyle = {
  position: "relative",
  zIndex: "999009",
}

class HelpCenter extends Component {
  componentDidMount() {
    window.scrollTo(0, 0)
    M.AutoInit();
  }
  render() {
    return (
      <div className="grey lighten-5" >

        <div className="card-panel white-text teal lighten-1" style={jumbotronStyle}>
          <ParticlesContainer>
          </ParticlesContainer>
          <div className="container white-text" style={insideStyle}>
            <h4>Q&A</h4>
          </div>


        </div>

        <div className="mainpage container z-depth-0 ">
          {/* <div className="row"> */}


          <ul className="collapsible expandable">
            <li className="active">
              <div className="collapsible-header">Is cusary a D-App?</div>
              <div className="collapsible-body"><span>Yes, cusary is a D-App, however, it’s not on blockchain. Our service has it’s backend code running on a IPFS decentralized peer-to-peer distributed network. We choose IPFS since it’s faster and more reliable for storage use yet decentralised. All documents are secure from intentional overwrite once they are stored in the cusaly storage.</span></div>
            </li>
            <li>
              <div className="collapsible-header">Is IPFS secure and trustable?</div>
              <div className="collapsible-body"><span>For the security of IPFS please check their website. www.IPFS.io</span></div>
            </li>
            <li>
              <div className="collapsible-header">Are all legal template reviewed by professionals?</div>
              <div className="collapsible-body"><span>Yes, we have reviewed our document legally. Also you can add your own legal template on cusaly in addition to our standard template.</span></div>
            </li>
            <li>
              <div className="collapsible-header">Do you have APIs</div>
              <div className="collapsible-body"><span>We are planning to launch our API to connect internal or cloud file storages, however, we are still not ready to make it happen. As soon as we got enough feedback in terms of technical and usability, we are going forward to move in the phase.</span></div>
            </li>
            <li>
              <div className="collapsible-header">Can’t find PRO/PREMIUM version on your website</div>
              <div className="collapsible-body"><span>We are preparing PRO version now. For now please create a FREE version account from HERE. As soon as we are ready, will announce you.</span></div>
            </li>
          </ul>
        </div>

        {/* space */}

        <div className="row">
        </div>
      </div >
    )
  }
}

export default withRouter(HelpCenter);